var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{attrs:{"title":"test dialog","on-ok":_vm.onOk,"on-cancel":_vm.onCancel,"on-close":_vm.onClose},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._v(" TO JEST TESTOWY DIALOG"),_c('br'),_vm._v(" a to jest tekst wypisany małymi literami ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }